/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateCategoryDto = {
    /**
     * Category name
     */
    name?: string;
    /**
     * Category code
     */
    code?: string;
    /**
     * Category description
     */
    description?: string;
    /**
     * Category status
     */
    status?: UpdateCategoryDto.status;
    /**
     * Source of creation
     */
    source?: UpdateCategoryDto.source;
};
export namespace UpdateCategoryDto {
    /**
     * Category status
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
    /**
     * Source of creation
     */
    export enum source {
        CATALOG = 'CATALOG',
        SETTINGS = 'SETTINGS',
    }
}

